import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950">
      <div className="w-full px-6 md:px-10 py-16 md:py-20">
        <div className="max-w-7xl mx-auto">
          {/* Top brand */}
          <div className="mb-16">
            <Link to="/" className="inline-flex items-center gap-2 cursor-pointer">
              <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-lg text-foreground-950"></i>
              </div>
              <span className="text-3xl md:text-4xl font-bold text-white whitespace-nowrap">
                CSSBuy Spreadsheet
              </span>
            </Link>
          </div>

          {/* Three columns */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-16">
            {/* Left - Description & Social */}
            <div>
              <p className="text-foreground-300 text-sm leading-relaxed mb-6 max-w-xs">
                O melhor CSSBuy Spreadsheet em português. Links verificados, produtos organizados e guias completos para compras seguras em Portugal e no Brasil.
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-300 hover:text-accent-500 hover:border-accent-500 transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-base"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-300 hover:text-accent-500 hover:border-accent-500 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-base"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-300 hover:text-accent-500 hover:border-accent-500 transition-colors cursor-pointer">
                  <i className="ri-discord-line text-base"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-300 hover:text-accent-500 hover:border-accent-500 transition-colors cursor-pointer">
                  <i className="ri-telegram-line text-base"></i>
                </a>
              </div>
            </div>

            {/* Middle - Contact */}
            <div className="space-y-8">
              <div>
                <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-2">Endereço</p>
                <p className="text-foreground-300 text-sm leading-relaxed">
                  cssbuyspreadsheet.cloud<br />
                  Disponível em Portugal e Brasil
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-2">Contato</p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-300 text-sm hover:text-accent-500 transition-colors"
                >
                  kaspreadsheet.com
                </a>
              </div>
            </div>

            {/* Right - Quick links */}
            <div>
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Categorias Populares</p>
              <div className="grid grid-cols-2 gap-2">
                {categories.slice(0, 8).map((cat) => (
                  <a
                    key={cat.seq}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 text-sm hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.namePt}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-800/50">
        <div className="w-full px-6 md:px-10 py-6">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; 2026 cssbuyspreadsheet.cloud — Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/" className="text-foreground-500 text-xs hover:text-accent-500 transition-colors whitespace-nowrap">
                Início
              </Link>
              <Link to="/guia-cssbuy-sheet-2026" className="text-foreground-500 text-xs hover:text-accent-500 transition-colors whitespace-nowrap">
                Artigos
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-foreground-500 text-xs hover:text-accent-500 transition-colors whitespace-nowrap"
              >
                Acessar
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}